var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('h1',[_vm._v("Classes")]),_c('ResponsiveTable',{attrs:{"headers":['Name', 'Code', ''],"rows":_vm.classes}}),_c('BaseButton',{attrs:{"type":"submit","href":{name: 'AdminClassesCreate'}}},[_vm._v(" Create class ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }